import { Layout } from 'antd';
import { FC } from 'react';
import { Header } from '../../../components';
import { StyledContent } from '../AdminLayout/style';

const NonAdminLayout: FC = ({ children }) => (
  <Layout>
    <Header />
    <StyledContent>{children}</StyledContent>
  </Layout>
);

export default NonAdminLayout;
